import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './BrandProducts.css'; // Reuse the same CSS as BrandProducts

const CategoryProducts = () => {
    const { categorySlug } = useParams();
    const navigate = useNavigate();
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Get API URL from environment variable
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                setLoading(true);
                const response = await fetch(`${API_URL}/products/category/${categorySlug}`);
                const data = await response.json();

                if (data.success) {
                    setProducts(data.data);
                } else {
                    setError('Failed to load products');
                }
            } catch (err) {
                console.error('Error fetching products:', err);
                setError('Failed to load products');
            } finally {
                setLoading(false);
            }
        };

        fetchProducts();
    }, [categorySlug, API_URL]);

    const getImageUrl = (localPath) => {
        // Remove /api from API_URL for images endpoint
        const baseUrl = API_URL.replace('/api', '');
        return `${baseUrl}/api/images/${localPath}`;
    };

    const getCategoryName = (slug) => {
        const categoryNames = {
            'led-lamps': 'LED Lamps',
            'lotion': 'Lotion',
            'sugar-scrub': 'Sugar Scrub',
            'mud-mask': 'Mud Mask',
            'pedicure-supplies': 'Pedicure Supplies',
            'massage-oil': 'Massage Oil'
        };
        return categoryNames[slug] || slug.replace('-', ' ').toUpperCase();
    };

    if (loading) {
        return (
            <div className="brand-products-container">
                <div className="loading">Loading products...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="brand-products-container">
                <div className="error">{error}</div>
            </div>
        );
    }

    return (
        <div className="brand-products-container">
            <div className="brand-header">
                <h1>{getCategoryName(categorySlug)} Products</h1>
                <p className="product-count">{products.length} products available</p>
            </div>

            <div className="products-grid">
                {products.map((product) => (
                    <div
                        key={product.id}
                        className="product-card"
                        onClick={() => navigate(`/products/${product.category_name || 'all'}/${product.id}`)}
                    >
                        <div className="product-image-container">
                            {product.local_path ? (
                                <img
                                    src={getImageUrl(product.local_path)}
                                    alt={product.name}
                                    className="product-image"
                                    onError={(e) => {
                                        e.target.src = '/images/placeholder.webp';
                                    }}
                                />
                            ) : (
                                <div className="no-image">No Image</div>
                            )}
                        </div>
                        <div className="product-info">
                            <h3 className="product-name">{product.name}</h3>
                            <p className="product-category">{product.vendor_name || 'Uncategorized'}</p>
                            <p className="product-price">
                                ${product.price ? Number(product.price).toFixed(2) : '0.00'}
                            </p>
                            {product.stock_quantity > 0 ? (
                                <span className="in-stock">In Stock</span>
                            ) : (
                                <span className="out-of-stock">Out of Stock</span>
                            )}
                        </div>
                    </div>
                ))}
            </div>

            {products.length === 0 && (
                <div className="no-products">
                    <p>No products found for {getCategoryName(categorySlug)}</p>
                </div>
            )}
        </div>
    );
};

export default CategoryProducts;
